import { getUser } from "$lib/userstorage/usersotrage";
import { handleAuthenticatedRequest, jsonOrThrow } from "../errores/erroresback"
import { queryClient, cacheRestored } from "$lib/query/queryClient"
import { queryKeys } from "$lib/query/keys"
let ruta_java = import.meta.env.VITE_RUTA_JAVA_SERVER;
let ruta_local_java = import.meta.env.VITE_RUTA_LOCAL_JAVA_SERVER;
let bd_local = import.meta.env.VITE_LOCAL_BD=="si";
let RUTA_JAVA =bd_local? ruta_local_java:ruta_java;
const RUTA_TACTOS = "pregnancy-checks"
// El backend guarda checkType como String libre y V16 pasó los existentes a
// MAYÚSCULAS ("TACTO", "ECOGRAFIA"), pero el front usa ids del store tipostacto
// ("tacto"/"eco"). Sin normalizar, el <select> de edición no matcheaba ningún
// option (desplegable en blanco) y el filtro por tipo (t.tipo == buscartipo)
// tampoco. Mapeamos a la forma canónica del front.
function normalizeCheckType(ct) {
    if (!ct) return "";
    const v = String(ct).toLowerCase();
    if (v.startsWith("eco")) return "eco";
    if (v.startsWith("tacto")) return "tacto";
    return v;
}
// El resultado del tacto es un tri-estado (EN_SERVICIO/PRENADA/VACIA, mismo
// enum que el estado reproductivo del animal), no un booleano: no hay forma
// de que "sin dato" y "En Servicio" colapsen al mismo valor como pasaba antes.
export function prenadaFromResult(result) {
    if (result === "PRENADA") return 2;
    if (result === "VACIA") return 0;
    if (result === "EN_SERVICIO") return 3;
    return 3;
}
export function resultFromPrenada(prenada) {
    if (prenada === 2) return "PRENADA";
    if (prenada === 0) return "VACIA";
    if (prenada === 3) return "EN_SERVICIO";
    return null;
}
function processTacto(tacto) {
    // Construir lista de animales desde la respuesta M2M del backend. Cada
    // animal trae su propio result/notes (puede diferir del general del
    // lote), por eso mapeamos prenada/observacion por animal acá también.
    let animales = (tacto.animals ?? []).map(a => ({
        id: a.animalId,
        caravana: a.tagNumber,
        prenada: prenadaFromResult(a.result),
        observacion: a.notes ?? "",
    }));
    // Fallback para registros legacy (animal_id directo, sin join table).
    if (animales.length === 0 && tacto.animalId) {
        animales = [{
            id: tacto.animalId,
            caravana: tacto.animalTagNumber ?? "",
            prenada: prenadaFromResult(tacto.result),
            observacion: tacto.notes ?? "",
        }];
    }
    let firstAnimal = animales.length > 0 ? animales[0] : {id: null, caravana: ""};
    let data_tacto = {
        id: tacto.pregnancyCheckId,
        fecha: tacto.date,
        observacion: tacto.notes ?? "",
        animal: firstAnimal.id,
        tipo: normalizeCheckType(tacto.checkType),
        prenada: prenadaFromResult(tacto.result),
        categoria: "",
        animales: animales,
        expand: {
            animal: {
                id: firstAnimal.id,
                caravana: firstAnimal.caravana,
            }
        }
    }
    return data_tacto;
}
export function processTactos(data) {
    let data_tactos = []
    for (let i = 0; i < data.length; i++) {
        let fila = data[i]
        data_tactos.push(processTacto(fila))
    }
    return data_tactos
}
function isRealError(err) {
    return !!err && (err.message === "SESIÓN_EXPIRADA" || err.message === "SIN_PERMISO" || typeof err.status === "number")
}
export async function getAll(cabid=null) {

    let user = getUser();
    let token = user.token;

    let ruta = `${RUTA_JAVA}${RUTA_TACTOS}/all`
    let url = new URL(ruta)
    if (cabid) {
        url.searchParams.append('establishmentId', cabid);
    }
    let options = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }
    try {
        let res_all = await handleAuthenticatedRequest(url.toString(), options)

        let data_all = await jsonOrThrow(res_all, "tactos.getAll")

        return processTactos(data_all)
    } catch (err) {
        if (isRealError(err)) throw err
        await cacheRestored
        const cached = cabid ? queryClient.getQueryData(queryKeys.pregnancyChecks(cabid)) : null
        if (Array.isArray(cached)) return cached
        throw err
    }
}
export async function getTactoId(id) {
    let ruta = `${RUTA_JAVA}${RUTA_TACTOS}/${id}`
    let user = getUser();
    let token = user.token;
    let options = {
        headers: {
            
            "Authorization": `Bearer ${token}`
        }
    }
    let res_all = await fetch(ruta,options)
    let data_all = await res_all.json()
    let procesada = processTacto(data_all)
    return procesada
}
function postData(data,establishmentId=1) {
    
    let data_tacto = {
        animalId: data.animal,
        date: data.fecha.split(" ")[0],
        checkType: data.tipo,

        result: resultFromPrenada(data.prenada),
        notes: data.observacion,
        establishmentId:data.cab
    }
    return data_tacto
}

export async function saveTacto(data) {
    let ruta = `${RUTA_JAVA}${RUTA_TACTOS}`

    let data_tacto = postData(data)
    let user = getUser();
    let token = user.token;
    let res_save = await fetch(ruta, {
        method: "POST",
        body: JSON.stringify(data_tacto), // data can be `string` or {object}!
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
    })
    let data_save = await res_save.json()
    return data_save

}
export async function editTacto(id, data) {
    let ruta = `${RUTA_JAVA}${RUTA_TACTOS}/${id}`

    let user = getUser();
    let token = user.token;
    let res_post = await fetch(ruta,
        {
            method: "PUT",
            body: JSON.stringify(data), // data can be `string` or {object}!
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
        }
    )

    let data_post = await res_post.json()
    return data_post
}
export async function eliminarTacto(id) {
    let ruta = `${RUTA_JAVA}${RUTA_TACTOS}/delete/${id}`
    let user = getUser();
    let token = user.token;
    let res_post = await fetch(ruta,
        {
            method: "POST",
            //            body: JSON.stringify({}), // data can be `string` or {object}!
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
        }
    )

    //let data_post = await res_post.json()
    return {}
}